import React, { useEffect, useState } from 'react';
import IncreaseDecreaseInputButton from '../IncreaseDecreaseInputButton';
import { IMeasureUnit } from '../../../store/ducks/long-steel-shopping-cart/types';
import {
  isInvalidMultipleValue,
  isLoweThanMinimumQty
} from '../../../pages/Purchase/LongSteel/OrderSettings/ShoppingCartTable/shoppingCartFieldsValidation';
import { Container } from './styles';

export interface QuantityInputProps {
  value: string;
  onChange(value: string): void;
  isMultipleSelectField?: boolean;
  measureUnit?: IMeasureUnit;
  label?: string;
  width?: string;
  disableInput?: boolean;
  readOnly?: boolean;
}

const QuantityInput: React.FC<QuantityInputProps> = ({
  value,
  measureUnit,
  onChange,
  isMultipleSelectField,
  label,
  width,
  disableInput,
  readOnly
}) => {
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const updateErrorMessage = () => {
      setErrorMessage('');
      if (!isMultipleSelectField && measureUnit && value !== '') {
        if (isInvalidMultipleValue(measureUnit, value)) {
          setErrorMessage(
            `O valor precisa ser múltiplo de: ${Number(measureUnit?.multiple)}`
          );
        } else if (isLoweThanMinimumQty(measureUnit, value)) {
          setErrorMessage(
            `O valor mínimo é: ${Number(measureUnit?.minimumQuantity)}`
          );
        }
      }
    };
    updateErrorMessage();
  });

  const onIncrease = () => {
    const increaseValue = Number((measureUnit as IMeasureUnit).multiple);
    const minimumQuantity = parseFloat(
      (measureUnit as IMeasureUnit).minimumQuantity
    );
    let newValue = 0;

    if (
      !isMultipleSelectField &&
      increaseValue !== 0 &&
      isInvalidMultipleValue(measureUnit as IMeasureUnit, value)
    ) {
      const factor = Math.ceil(Number(value) / increaseValue); // arredonda o valor digitado para cima
      newValue = factor * increaseValue;
    } else {
      newValue = Number(value) + increaseValue;
    }

    if (
      (parseFloat(value || '0') === 0 ||
        parseFloat(value || '0') < minimumQuantity) &&
      minimumQuantity > 0 &&
      !isMultipleSelectField
    ) {
      newValue = minimumQuantity;
    }

    onChange(Number(newValue.toFixed(3)).toString());
  };

  const onDecrease = () => {
    const decreaseValue = parseFloat((measureUnit as IMeasureUnit).multiple);
    const minimumQuantity = parseFloat(
      (measureUnit as IMeasureUnit).minimumQuantity
    );
    let newValue = 0;

    if (
      decreaseValue !== 0 &&
      isInvalidMultipleValue(measureUnit as IMeasureUnit, value)
    ) {
      const factor = Math.floor(Number(value) / decreaseValue); // arredonda o valor digitado para baixo
      newValue = factor * decreaseValue;
    } else {
      newValue = Number(value) - decreaseValue;
    }

    if (newValue < minimumQuantity && !isMultipleSelectField) {
      newValue = 0;
    }

    onChange(Number(newValue.toFixed(3)).toString());
  };

  return (
    <Container widthRem={width}>
      {isMultipleSelectField && (
        <IncreaseDecreaseInputButton
          label={label ?? ''}
          value={value ? value + 'x' : ''}
          disabled={!measureUnit}
          onChange={(value: string) => onChange(value)}
          onIncreaseClick={onIncrease}
          onDecreaseClick={onDecrease}
          errorMessage={errorMessage}
          disabledInput={disableInput}
          readOnly={readOnly ?? false}
        />
      )}

      {!isMultipleSelectField && (
        <IncreaseDecreaseInputButton
          label={label ?? ''}
          value={value}
          disabled={!measureUnit}
          onChange={(value: string) => onChange(value)}
          onIncreaseClick={onIncrease}
          onDecreaseClick={onDecrease}
          errorMessage={errorMessage}
          disabledInput={disableInput}
          readOnly={readOnly ?? false}
        />
      )}
    </Container>
  );
};

export default QuantityInput;
